<template>
  <div id="washingVolume">
    <div class="bg-color-black">
      <!-- 标题 -->
      <div class="title-box">
        <div class="title">洗涤厂实时数据汇总</div>
      </div>

      <!-- 表头 -->
      <div class="table-header">
        <div class="col-code">工厂代码</div>
        <div class="col-year">年洗涤</div>
        <div class="col-month">月洗涤</div>
        <div class="col-day">日洗涤</div>
      </div>

      <!-- 表格内容 - 循环滚动 -->
      <div
        class="table-body"
        ref="tableBody"
        :style="{ height: `${visibleRows * rowHeight}px` }"
        @mouseenter="stopScroll"
        @mouseleave="startScroll"
      >
        <!-- 滚动内容区域 -->
        <div class="scroll-wrapper" :class="{ scrolling: isScrolling }">
          <!-- 第一组数据 -->
          <div class="scroll-content">
            <div
              v-for="(item, index) in displayList"
              :key="item.serviceProviderId + '_first_' + index"
              class="table-row"
            >
              <div class="col-code" :title="item.serviceProviderCode">
                {{ item.serviceProviderCode || "-" }}
              </div>
              <div class="col-year">{{ item.yearNumReceive || 0 }}</div>
              <div class="col-month">{{ item.monthNumReceive || 0 }}</div>
              <div class="col-day">{{ item.dayNumReceive || 0 }}</div>
            </div>
          </div>
          <!-- 复制一组数据用于无缝滚动 -->
          <div class="scroll-content copy">
            <div
              v-for="(item, index) in displayList"
              :key="item.serviceProviderId + '_copy_' + index"
              class="table-row"
            >
              <div class="col-code" :title="item.serviceProviderCode">
                {{ item.serviceProviderCode || "-" }}
              </div>
              <div class="col-year">{{ item.yearNumReceive || 0 }}</div>
              <div class="col-month">{{ item.monthNumReceive || 0 }}</div>
              <div class="col-day">{{ item.dayNumReceive || 0 }}</div>
            </div>
          </div>
        </div>
        <div v-if="displayList.length === 0" class="empty-tip">暂无数据</div>
      </div>
    </div>
  </div>
</template>

<script>
import * as api from "@/api/index";

export default {
  data() {
    return {
      displayList: [],
      params: {
        customerId: "",
      },
      intervalId: null,
      isScrolling: false,
      animationFrameId: null,
      scrollPosition: 0,
      rowHeight: 42,
      visibleRows: 3,
    };
  },
  mounted() {
    this.params.customerId = this.$route.query.customerId;

    this.getData();

    this.intervalId = setInterval(() => {
      this.getData();
    }, 30 * 60 * 1000);
  },
  beforeDestroy() {
    if (this.intervalId) {
      clearInterval(this.intervalId);
    }
    this.stopScroll();
  },
  methods: {
    stopScroll() {
      this.isScrolling = false;
      if (this.animationFrameId) {
        cancelAnimationFrame(this.animationFrameId);
        this.animationFrameId = null;
      }
    },

    startScroll() {
      if (this.displayList.length <= this.visibleRows) {
        return;
      }

      if (this.isScrolling) {
        return;
      }

      this.isScrolling = true;
      this.animate();
    },

    animate() {
      if (!this.isScrolling) return;

      this.scrollPosition += 0.25;

      const totalHeight = this.displayList.length * this.rowHeight;
      if (this.scrollPosition >= totalHeight) {
        this.scrollPosition = 0;
      }

      const scrollWrapper = this.$refs.tableBody;
      if (scrollWrapper) {
        const scrollContent = scrollWrapper.querySelector(".scroll-wrapper");
        if (scrollContent) {
          scrollContent.style.transform = `translateY(-${this.scrollPosition}px)`;
        }
      }

      this.animationFrameId = requestAnimationFrame(() => this.animate());
    },

    async getData() {
      const params = {};
      const res = await api.getBigServiceProvider(params);

      if (res.ResultCode != 0) return;

      const data = res.Result || [];
      this.displayList = data;

      this.$nextTick(() => {
        this.stopScroll();
        this.startScroll();
      });
    },
  },
};
</script>

<style lang="scss" scoped>
#washingVolume {
  width: 100%;
  height: 100%;
  border-radius: 5px;

  .bg-color-black {
    height: 100%;
    border-radius: 10px;
    padding: 0 20px;
    display: flex;
    flex-direction: column;

    .title-box {
      display: flex;
      flex-direction: row;
      align-items: center;
      padding-top: 5%;
      padding-bottom: 3%;
      flex-shrink: 0;

      .title {
        font-size: 18px;
        color: #00cdff;
      }
    }

    .table-header {
      display: flex;
      flex-shrink: 0;
      padding: 10px 0;
      border-bottom: 1px solid rgba(255, 255, 255, 0.1);
      font-size: 14px;
      color: #8e9eae;

      .col-code {
        width: 25%;
      }
      .col-year {
        width: 25%;
        text-align: center;
      }
      .col-month {
        width: 25%;
        text-align: center;
      }
      .col-day {
        width: 25%;
        text-align: center;
      }
    }

    .table-body {
      flex-shrink: 0;
      overflow: hidden;
      position: relative;

      .scroll-wrapper {
        &.scrolling {
          will-change: transform;
        }
      }

      .table-row {
        display: flex;
        height: 42px;
        line-height: 42px;
        padding: 0;
        border-bottom: 1px solid rgba(255, 255, 255, 0.05);
        font-size: 14px;
        color: #fff;
        transition: background 0.3s;

        &:hover {
          background: rgba(255, 255, 255, 0.05);
        }

        .col-code {
          width: 25%;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }

        .col-year {
          width: 25%;
          text-align: center;
        }

        .col-month {
          width: 25%;
          text-align: center;
        }

        .col-day {
          width: 25%;
          text-align: center;
        }
      }

      .empty-tip {
        text-align: center;
        padding: 40px 0;
        color: #8e9eae;
        font-size: 14px;
      }
    }
  }
}

@media screen and (max-width: 1280px) {
  #washingVolume {
    .table-header,
    .table-body .table-row {
      .col-code {
        width: 25%;
      }
      .col-year {
        width: 25%;
      }
      .col-month {
        width: 25%;
      }
      .col-day {
        width: 25%;
      }
    }
  }
}
</style>


